import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getSerialCodeStats,
  SerialCodeStatsData,
} from '@/application/requests/serialCode';

export interface SerialCodeStatsState {
  stats: SerialCodeStatsData | null;
  loading: boolean;
  error: string | null;
}

const initialState: SerialCodeStatsState = {
  stats: null,
  loading: false,
  error: null,
};

export const fetchSerialCodeStats = createAsyncThunk(
  'serialCodeStats/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSerialCodeStats();

      if (!response.success) {
        return rejectWithValue(
          response.message || 'Failed to fetch serial code stats'
        );
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.message || 'Failed to fetch serial code stats'
      );
    }
  }
);

const serialCodeStatsSlice = createSlice({
  name: 'serialCodeStats',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetStats: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSerialCodeStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSerialCodeStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload || null;
      })
      .addCase(fetchSerialCodeStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, resetStats } = serialCodeStatsSlice.actions;

export default serialCodeStatsSlice.reducer;
